import { render, staticRenderFns } from "./TrocarSenha.vue?vue&type=template&id=16bafa06&scoped=true"
import script from "./TrocarSenha.vue?vue&type=script&lang=ts"
export * from "./TrocarSenha.vue?vue&type=script&lang=ts"
import style0 from "./TrocarSenha.vue?vue&type=style&index=0&id=16bafa06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bafa06",
  null
  
)

export default component.exports